import Request from '../utils/request';
let request = new Request().http;
let _get_http = new Request().get_http;

export default {
  async uploadFile(file) {
    const data = new FormData()
    data.append('file', file)
    const res = await request('/api/file/upload', data, 'POST')
    if (res.ok) {
      return res.data.uuid
    }
    return ''
  },
  imgUrl(id) {
    return `/api/file/preview/${id}`
  },

  // 登录
  loginPicConfig() {
    return request('/api/common/position/public/loginPicConfig/content', {}, 'GET')
  },

  // 检查实名
  jiachashiming() {
    return request(`/api/cdkelong_mall/user/me/other`, {}, 'GET')
  },
  // 检查是否有k3信息
  isHaveK3(e) {
    return request(`/api/cdkelong_mall/pay_order/checkUserK3Id/${e}`, {}, 'GET')
  },
  // 获取易制爆可用证书
  getmyPage() {
    return request(`/api/cdkelong_mall/orders_certificate_explosive/myPage`, {}, 'GET')
  },
  // 获取易制毒可用证书
  getmyPageDu() {
    return request(`/api/cdkelong_mall/orders_certificate_drug/myPage`, {}, 'GET')
  },
  // 上传易制爆可用证书
  pushYizhibao(data) {
    return request(`/api/cdkelong_mall/orders_certificate_explosive`, data, 'POST')
  },
  // 上传易制毒可用证书
  pushYizhidu(data) {
    return request(`/api/cdkelong_mall/orders_certificate_drug`, data, 'POST')
  },
  // 上传易制毒可用证书
  pushYizhidu_detail(data) {
    return request(`api/cdkelong_mall/orders_certificate_drug/update`, data, 'POST')
  },
  // 订单支付
  payOrder(id) {
    return request(`/api/cdkelong_mall/pay_order/${id}`, {}, 'GET')
  },
  ordersWxpay(id) {
    return request('/api/cdkelong_mall/pay_order/orders/wxpay/QRcode', {
      list: [id]
    }, 'POST')
  },
  // 易制毒上传回执
  orderhuizhi(e) {
    return request(`/api/cdkelong_mall/orders/${e.uuid}/precursorChemicalsReceipt`, {
      ...e
    }, 'POST')
  },
  // 订单预结算
  orderYujiesuan(e) {
    return request('/api/cdkelong_mall/cart/getCarOrderInfo', e, 'POST')
  },
  // 购物车下单获取运费
  ordercardyunfei(e) {
    return request('/api/cdkelong_mall/orders/buyCart/calculate', {
      e
    }, 'POST')
  },
  // 购物车提交结算
  ordercardjiesuan(data) {
    return request('/api/cdkelong_mall/orders/buyCart', data, 'POST')
  },
  // 批量采购
  piliangcaigou(e) {
    return request('/api/cdkelong_mall/find_goods_batch/public', e, 'POST')
  },
  ordersCheckPaid(id) {
    return request(`/api/cdkelong_mall/pay_order/${id}/checkPaid`, {}, 'POST', false)
  },

  // 订单
  calculateFreight(data) { // 购物车-下单 计算运费
    return request('/api/cdkelong_mall/orders/buyCart/calculateFreight', data, 'POST');
  },
  afterSaleReply(id, content) {
    return request(`/api/cdkelong_mall/orders/${id}/afterSaleReply`, {
      content
    }, 'POST');
  },
  ordersMyStats() {
    return request('/api/cdkelong_mall/orders/myStats', {}, 'GET');
  },
  calculateBuy(data) {
    return request('/api/cdkelong_mall/orders/buy/calculate', data, 'POST')
  },
  // 获取运费接口
  calculateBuyCart(data) {
    return request('/api/cdkelong_mall/orders/buyCart/calculate', data, 'POST')
  },

  // 代理
  agent_application_post(data) {
    return request('/api/cdkelong_mall/agent_application', data, 'POST');
  },
  // 系统消息
  system_message_unreadCount() {
    return request('/api/system_message/unreadCount', {}, 'GET');
  },

  // 注册
  register: function (e) {
    return request('/api/user/register/public', {
      username: e.username,
      password: e.password,
      passwordCopy: e.passwordCopy
    }, 'POST');
  },

  // 登录
  login: function (e) {
    return request('/api/auth/public/login', {
      data: {
        username: e.username,
        password: e.password
      },
      type: 'username_and_password',
      realm: 'system'
    }, 'POST');
  },
  // 获取图形验证码
  get_numcode(e) {
    return request('/api/auth/public/random?mobile=' + e.mobile, 'POST');
  },

  // 验证码登录注册
  code_login: function (e) {
    return request('/api/auth/public/login', e, 'POST');
  },

  // 我的信息
  user_info: function (e) {
    return request('/api/cdkelong_mall/user/me', null, 'GET');
  },

  // 查看红票
  redPiao: function (e) {
    return request(`/api/cdkelong_mall/invoice/selectReadInvoice/${e}`, null, 'GET');
  },



  wx_info: function (e) {
    return request(`/api/oauth/binding/${e}`, null, 'GET');
  },
  // 资讯分类类别
  newsClasstList: function (e) {
    return request('/api/cdkelong_mall/firstSort/sortList', null, 'GET');
  },

  // 文章二级分类管理
  secondSort: function (e) {
    return request('/api/cdkelong_mall/secondSort', null, 'GET');
  },

  // 商品列表
  goods_list: function (e) {
    return _get_http('/api/cdkelong_mall/product/public/page', e, 'GET');
  },
  // 获取图片
  get_preview: function (id) {
    return request(`/api/file/preview/${id}`, null, 'GET');
  },

  // 我的地址
  get_address: function (id) {
    return request(`/api/cdkelong_mall/address/search?userId=${localStorage.uuid}`, null, 'GET');
  },
  // 查询线下支付账号信息
  get_xinaxia: function (id) {
    return request(`/api/cdkelong_mall/store/getPublicAcc/${id}`, null, 'GET');
  },
  // 线下支付
  xianxiazhifu(e) {
    return request(`/api/cdkelong_mall/pay_order/payPrivately`, e, 'POST');
  },
  // 获取省市区列表列表
  get_all_available: function (id) {
    return request(`/api/setting_district/public/all_available`, null, 'GET');
  },

  // 获取文档列表
   get_file_list: function (params) {
    return request('api/cdkelong_mall/productFile/public/searchFile?productName=' + params.productName+'&fileTypes='+params.filetype + '&page=' + params.page + '&size=' + params.size + '&batch=' + params.pihao + '&packagingNew=' + encodeURI(params.jibie) + '&brandName=' + params.pinpai, null, 'GET');
  },
  // get_msds_list: function (params) {
  //   // console.log(params);
  //   return request('/api/cdkelong_mall/productFile/public/productFileMsdsPage?productName=' + params.productName + '&page' + '=' + params.page + '&size' + '=' + params.size + '&batch' + '=' + params.pihao + '&packagingNew' + '=' +encodeURI(params.jibie)  + '&brandName' + '=' + params.pinpai, null, 'GET');
  // },

  // get_coa_list: function (params) {
  //   return request('/api/cdkelong_mall/productFile/public/productFileCOAPage?productName=' + params.productName + '&page' + '=' + params.page + '&size' + '=' + params.size + '&batch' + '=' + params.pihao + '&packagingNew' + '=' + params.jibie + '&brandName' + '=' + params.pinpai, null, 'GET');
  // },

  // 品牌
  get_goods_type_pinpai(e) {
    return request(`/api/cdkelong_mall/productFile/public/findPackagingAndBrand?type=brand`, e, 'GET');
  },

  // 级别
  get_goods_type_jibie(e) {
    return request(`/api/cdkelong_mall/productFile/public/findPackagingAndBrand?type=packaging`, e, 'GET');
  },

  // 动态显示商品名称
  get_shop_list: function (productName) {
    return request('/api/cdkelong_mall/productFile/public/searchName?productName=' + productName, null, 'GET',false);
  },

  // 提交新增地址数据
  createOrUpdate: function (e) {
    return request(`/api/cdkelong_mall/address/createOrUpdate`, e, 'POST');
  },
  // 查看是否有证书
  get_cas_num: function (casNum) {
    return _get_http(`/api/cdkelong_mall/user_product/myAvailable?casNum=${casNum}`, null, 'GET');
  },

  // 删除地址
  deleteAddress: function (e) {
    return request(`/api/cdkelong_mall/address/delete?addressUUID=${e}`, e, 'GET');
  },

  // 设置成默认地址
  defaultAddress: function (e) {
    return request(`/api/cdkelong_mall/address/defaultAddress?addressUUID=${e}`, e, 'GET');
  },

  // 取消默认地址
  cancelAddress: function (e) {
    return request(`/api/cdkelong_mall/address/cancelAddress?addressUUID=${e}`, e, 'GET');
  },

  // 我的积分记录
  get_point_log: function (e) {
    return request(`/api/cdkelong_mall/point_log/pageMy?endTime=${e.endTime}&page=${e.page}&startTime=${e.startTime}`, e, 'GET');
  },

  // 我的积分
  get_pointMy: function (e) {
    return request(`/api/cdkelong_mall/pointMy`, e, 'GET');
  },

  // 我的收藏列表
  get_favorites: function (e) {
    return request(`/api/cdkelong_mall/favorites/search`, e, 'GET');
  },

  // 新增收藏
  add_favorites: function (e) {
    return request(`/api/cdkelong_mall/favorites/save?productId=${e}`, e, 'GET');
  },

  // 改变收藏状态 status id
  update_favorites: function (e) {
    return request(`/api/cdkelong_mall/favorites/update_status`, e, 'POST');
  },

  // 产品分类
  get_allAvailable: function (e) {
    return request(`/api/setting_tag_platform/public/allAvailable/type?pid=0&type=PRODUCT_CATEGORY`, e, 'GET');
  },

  // 获取所有可用的树结构简化信息
  get_allAvailableTree: function (e) {
    return request(`/api/setting_tag_platform/public/allAvailableTree/type?pid=0&type=PRODUCT_CATEGORY`, e, 'GET');
  },

  // 获取企业信息
  get_companyFullName: function (e) {
    return request(`/api/cdkelong_mall/user_company/me/companyFullName`, e, 'GET');
  },

  quanxcian: function (e) {
    return request(`/api/cdkelong_mall/home/s/clickCount`, e, 'GET');
  },

  // 获取商品列表下面的规格
  get_product_sku: function (e) {
    return request(`/api/cdkelong_mall/product_sku/public/page?productId=${e.productId}&page=${e.page}&storeId=${e.storeId}&size=${e.size}`, e, 'GET');
  },

  // 商品详情
  get_goods_details: function (e, i) {
    return request(`/api/cdkelong_mall/product/public/${e}?storeId=${i}`, e, 'GET');
  },

  // 加入购物车
  add_cart: function (e) {
    return request(`/api/cdkelong_mall/cart/add`, e, 'POST');
  },

  // 保存我的信息
  update_user_info: function (e) {
    return request(`/api/cdkelong_mall/user/updateMe`, e, 'POST');
  },

  // 商品规格切换
  update_product_sku: function (e) {
    return _get_http(`/api/cdkelong_mall/product_sku/public/list`, e, 'GET');
  },

  // 我的足迹
  get_footprint: function (e) {
    return request(`/api/cdkelong_mall/footprint/search?page=${e.page}&size=${e.size}`, e, 'GET');
  },

  // 购物车数量
  get_cart_count: function (e) {
    return request(`/api/cdkelong_mall/cart/myCount`, e, 'GET');
  },

  // 我的购物车
  get_all_cart: function (e) {
    return request(`/api/cdkelong_mall/cart/myAll?search=${e.search}`, e, 'GET');
  },

  // 改变购物车数量
  update_cart: function (e) {
    return request(`/api/cdkelong_mall/cart/update`, e, 'POST');
  },

  // 移入收藏夹
  moveFavorites: function (e) {
    return request(`/api/cdkelong_mall/cart/moveFavorites`, e, 'POST');
  },

  // 购物车创建订单
  cart_add_order: function (e) {
    return request(`/api/cdkelong_mall/orders/buyCart`, e, 'POST');
  },

  // 直接购买创建订单
  cart_add_buy_order: function (e) {
    return request(`/api/cdkelong_mall/orders/buy`, e, 'POST');
  },

  // 某商品可使用的促销集合
  get_promotionList: function (e) {
    return request(`/api/cdkelong_mall/store_promotion_product/public/promotionList?productId=${e.productId}`, e, 'GET');
  },

  //  积分配置获取
  get_pointRuleConfig: function (e) {
    return request(`/api/cdkelong_mall/public/pointRuleConfig`, e, 'GET');
  },

  //  某一批商品sku可使用的促销 这一批sku是一个店铺的
  get_list_promotionList: function (e) {
    return request(`/api/cdkelong_mall/store_promotion_product/public/promotion/sku`, e, 'POST');
  },

  //  选中购物车sku集合按店铺分组返回 附带可用促销
  get_cart_cuxiao: function (e) {
    return request(`/api/cdkelong_mall/cart/cartOrder`, e, 'POST');
  },

  //  用户-我的订单列表
  get_my_orders: function (e) {
    return _get_http(`/api/cdkelong_mall/orders/page`, e, 'GET');
  },

  //  用户-我的订单列表
  isOpen: function (e) {
    return _get_http(`api/cdkelong_mall/store/checkCustomerState/${e}`, 'GET');
  },
  //  用户-我的订单列表
  tiaozhuan: function (e) {
    return _get_http(`/api/public/message/addMessageToStore?storeId=${e.storeId}&userId=${e.userId}`, 'GET');
  },

  // 订单详情
  get_orders_details: function (e) {
    return request(`/api/cdkelong_mall/orders`, e, 'POST');
  },

  // 获取消息列表，注意是按照时间倒序，timeModel 决定了是获取时间点更老的数据还是更新的数据
  get_session_message_list: function (e) {
    return _get_http(`/api/message/session_message_list`, e, 'GET');
  },

  // 创建资源
  add_user_certificate: function (e) {
    return request(`/api/cdkelong_mall/user_certificate`, e, 'POST');
  },
  // 退还订单
  tuihuandingdan: function (e) {
    return request(`/api/cdkelong_mall/orders/afterSale2`, e, 'POST');
  },
  edit_user_certificate: function (e) {
    return request(`/api/cdkelong_mall/user_certificate`, e, 'POST');
  },
  get_user_certificate: function () {
    return request(`/api/cdkelong_mall/user_certificate/list?userId=${localStorage.uuid}`, {}, 'GET');
  },

  // 批量删除 单独就传一个 参数传商品skuId集合
  delete_cart_goods: function (e) {
    return request(`/api/cdkelong_mall/cart/delete`, e, 'POST');
  },

  // 用户-获取一批订单的详情, 同时返回多个订单的总计金额
  get_order_batchDetail: function (e) {
    return request(`/api/cdkelong_mall/orders/batchDetail`, e, 'POST');
  },

  // 前台授信查询
  // get_credit_search: function(e) {
  //     return request(`/api/cdkelong_mall/credit/search?page=${e}`, e, 'GET');
  // },

  // 授信查询(改)
  get_credit_search: function (e) {
    return request(`/api/cdkelong_mall/credit/searchStore?storeId=${e.storeId}`, {}, 'GET');
  },

  // 授信支付
  creditExtension: function (e) {
    return request(`/api/cdkelong_mall/pay_order/creditExtension`, e, 'POST');
  },

  // 订单详情查看：订单所有者--店铺管理人--管理员
  get_order_jindu: function (e) {
    return request(`/api/cdkelong_mall/orders/${e}`, e, 'GET');
  },

  // 用户-确认收货
  order_received: function (e) {
    return request(`/api/cdkelong_mall/orders/${e.id}/received`, e, 'POST');
  },

  // 用户-取消订单-下单未支付可以取消
  order_cancel: function (e) {
    return request(`/api/cdkelong_mall/orders/${e}/cancel`, {}, 'POST');
    ///api/cdkelong_mall/orders/s/{id}/cancel
  },

  // 前台列出文章资源 articleTitle: 标题; firstSort：第一类别; secondSort：第二类别(数组)
  get_news_list: function (e) {
    return request(`/api/cdkelong_mall/information/frontDeskPage`, e, 'POST');
  },

  // 反馈
  message_list(data) {
    return request(`/api/cdkelong_mall/complaint/pageMy?search=${data.search}&page=${data.page}&size=10`, data, 'GET');
  },

  // 新增反馈
  add_feedback(data) {
    return request('/api/cdkelong_mall/complaint/create', data, 'POST');
  },

  // 获取登陆验证码
  get_verifycode(d) {
    return request(`/api/auth/public/login/verifycode?mobile=${d.phone}&random=${d.random}&key=${d.key}`, 'GET', false);
  },

  // public热销商品
  get_hot_goods(e) {
    return request(`/api/cdkelong_mall/product/public/page/hot?page=${e}`, e, 'GET');
  },

  // 取消收藏
  cancel_favorites(e) {
    return request(`/api/cdkelong_mall/favorites/cancel?ids=` + e, {}, 'GET');
  },

  // 找货
  create_findGoods(e) {
    return request(`/api/cdkelong_mall/findGoods/create`, e, 'POST');
  },

  // 是否设置了密码
  is_pwdSetFirst(e) {
    return request(`/api/user_portal/me/pwdSetFirst`, e, 'GET');
  },
  is_pwdSetFirst2() {
    return request(`/api/auth/public/judgeTwo`, {}, 'GET');
  },
  // 修改密码
  reset_password(e) {
    return request(`/api/user_portal/reset_password`, e, 'POST');
  },

  /**
   * 商品分类页接口
   * @param {*} e
   *  pack 包装 /api/common/position/public/pack/content
      delivery 交期 /api/common/position/public/delivery/content
      price 价格 /api/common/position/public/price/content
      /api/setting_tag_platform/public/allAvailable/type?type=BRAND @有理想 品牌用这个
   */

  // 包装
  get_goods_type_pack(e) {
    return request(`/api/common/position/public/pack/content`, e, 'GET');
  },

  // 交期
  get_goods_type_delivery(e) {
    return request(`/api/common/position/public/delivery/content`, e, 'GET');
  },

  // 价格
  get_goods_type_price(e) {
    return request(`/api/common/position/public/price/content`, e, 'GET');
  },
  // 级别
  get_goods_type_packagingNew(e) {
    return request(`/api/cdkelong_mall/packagingNew/public/all`, e, 'GET');
  },
  // 包装材料
  get_goods_type_goodsPackage(e) {
    return request(`/api/common/position/public/goodsPackage/content`, e, 'GET');
  },
  // 品牌
  get_goods_type_allAvailable(e) {
    return request(`/api/setting_tag_platform/public/allAvailable/type?type=BRAND`, e, 'GET');
  },

  // 所属商家
  get_goods_type_storeIdArray(e) {
    return request(`api/cdkelong_mall/store/m/public/all`, e, 'GET');
  },

  // 文章详细
  get_news_detail(e) {
    return request(`/api/cdkelong_mall/information/detail?informationId=${e}`, e, 'GET');
  },

  // 获取新闻页顶部图片
  get_news_top_img(e) {
    return request(`/api/common/position/public/information/content`, e, 'GET');
  },

  // 前台最新资讯
  get_news_upToDate(e) {
    return request(`/api/cdkelong_mall/information/upToDate`, e, 'GET');
  },

  // 新建发票
  add_user_invoice(e) {
    return request(`/api/cdkelong_mall/user_invoice`, e, 'POST');
  },

  // 我的发票
  get_user_invoice(e) {
    return request(`/api/cdkelong_mall/user_invoice/myFirst?type=${e}`, e, 'GET');
  },

  // 编辑发票
  edit_user_invoice(e) {
    return request(`/api/cdkelong_mall/user_invoice/${e.id}`, e, 'POST');
  },

  // 初次第一次设置密码
  pwdSetFirst(e) {
    return request(`/api/user_portal/me/pwdSetFirst`, e, 'POST');
  },

  // 删除足迹
  delete_footprint(e) {
    return request(`/api/cdkelong_mall/footprint/delete?ids=${e}`, e, 'POST');
  },

  /**
   * 更换手机
   */
  // 原手机发送验证码
  chang_tel_v_code(e) {
    return request(`/api/user/mobile/verifycode?mobile=${e}&random=手机相关`, e, 'GET');
  },

  // 原手机验证码校验 true-正确 否则报错
  chang_tel_valid_verifycode(e) {
    return request(`/api/user/mobile/verifycode/valid?verifycode=${e}`, e, 'GET');
  },

  // 新手机发送验证码
  chang_tel_newMobile(e) {
    return request(`/api/user/mobile/verifycode/newMobile?newMobile=${e}`, e, 'GET');
  },

  // 变更为新手机
  chang_tel_updateMobile(e) {
    return request(`/api/user/mobile/verifycode/updateMobile`, e, 'POST');
  },

  // 忘记密码发送验证码
  forgetPwd_verifycode(e) {
    return request(`/api/auth/public/forgetPwd/verifycode/mobile?mobile=${e}`, e, 'GET');
  },

  // 忘记密码验证验证码
  forgetPwd_valid(e) {
    return request(`/api/auth/public/forgetPwd/verifycode/mobile/valid?mobile=${e.mobile}&verifycode=${e.verifycode}`, e, 'GET');
  },

  // 通过手机号码重置密码
  verifycode_reset_pwd(e) {
    return request(`/api/auth/public/forgetPwd/verifycode/reset_pwd`, e, 'POST');
  },
  //删除
  delete_favorite(e) {
    return request(`/api/cdkelong_mall/favorites/${e}/delete`, e, 'POST');
  },
  // 删除多条 id 用英文逗号分割
  delete_favorites(e) {
    return request(`/api/cdkelong_mall/favorites/delete?ids=${e}`, e, 'POST');
  },

  // 收藏查询有的品牌
  get_favorites_searchBrand(e) {
    return request(`/api/cdkelong_mall/favorites/searchBrand`, e, 'GET');
  },

  // 收藏查询 time:1=一个月内 3=三个月内 6=半年内 12=一年内
  get_search_favorites(e) {
    let _q = '';
    if (e.time) {
      _q = `page=${e.page}&time=${e.time}&search=${e.search}`;
    } else {
      _q = `page=${e.page}&search=${e.search}`;
    }
    return request(`/api/cdkelong_mall/favorites/search?${_q}`, e, 'GET');
  },

  // 查看反馈查看详情
  get_complaint_details(e) {
    return request(`/api/cdkelong_mall/complaint/${e}`, e, 'GET');
  },

  /**
   * UserInvoiceReceive-用户发票接收方式
  User Invoice Receive Controller
   */

  // 获取我的发票接收方式列表
  get_user_invoice_receive(e) {
    return request(`/api/cdkelong_mall/user_invoice_receive/myAll`, e, 'GET');
  },

  // 新增
  add_user_invoice_receive(e) {
    let query = '';
    if (e.uuid) {
      query = `/api/cdkelong_mall/user_invoice_receive/${e.uuid}`;
    } else {
      query = `/api/cdkelong_mall/user_invoice_receive`;
    }
    return request(query, e, 'POST');
  },

  // 查看详情
  get_user_invoice_receive_details(e) {
    return request(`/api/cdkelong_mall/user_invoice_receive/${e}`, e, 'GET');
  },

  // 删除
  delete_user_invoice_receive(e) {
    return request(`/api/cdkelong_mall/user_invoice_receive/${e}/delete`, e, 'POST');
  },

  // 获取我的消息列表
  get_my_message_list(e) {
    return _get_http(`/api/message/message_list`, e, 'GET');
  },

  // 满意度设置 satisfaction点啥传啥 例：满意就传满意
  complaint_satisfaction(e) {
    return _get_http(`/api/cdkelong_mall/complaint/satisfaction`, e, 'GET');
  },

  // 用户订单申请开票
  user_order_add_invoice(e) {
    return request(`/api/cdkelong_mall/invoice`, e, 'POST');
  },

  // 我的开票记录
  get_my_invoice_myPage(e) {
    return _get_http(`/api/cdkelong_mall/invoice/myPage`, e, 'GET');
  },

  // 查看开票详情 通过订单id
  get_invoice_details(e) {
    return request(`/api/cdkelong_mall/invoice/${e}`, e, 'GET');
  },

  // 保存用户企业信息
  save_user_company(e) {
    return request(`/api/cdkelong_mall/user_company/saveMe`, e, 'POST');
  },

  // 热门搜索
  index_hotSearch(e) {
    return request(`/api/common/position/public/hotSearch/content`, e, 'GET');
  },

  /**
   * * 首页banner /api/common/position/public/banner/content
   * 首页快速入口 /api/common/position/public/quickEntry/content
   * 首页资讯 /api/common/position/public/information/content
   * 底部入口链接 /api/common/position/public/bottomEntry/content
   * 底部二维码文字 /api/common/position/public/picInfo/content
   * 底部客服信息 /api/common/position/public/customerService/content
   */

  // 首页banner
  get_index_banner(e) {
    return request(`/api/common/position/public/banner/content`, e, 'GET');
  },

  // 首页快速入口
  get_index_quickEntry(e) {
    return request(`/api/common/position/public/quickEntry/content`, e, 'GET');
  },

  // 首页资讯
  get_index_information(e) {
    return request(`/api/common/position/public/information/content`, e, 'GET');
  },

  // 底部入口链接
  get_index_bottomEntry(e) {
    return request(`/api/common/position/public/bottomEntry/content`, e, 'GET');
  },

  // 底部二维码文字
  get_index_picInfo(e) {
    return request(`/api/common/position/public/picInfo/content`, e, 'GET');
  },

  // 底部客服信息
  get_index_customerService(e) {
    return request(`/api/common/position/public/customerService/content`, e, 'GET');
  },

  // 获取公共配置信息
  get_public_Info(e) {
    return request(`/api/common/position/public/otherConfig/content`, e, 'GET');
  },

  // 用户-申请售后
  add_user_afterSale(e) {
    return request(`/api/cdkelong_mall/orders/${e.id}/afterSale`, e, 'POST');
  },

  // 我的系统消息通知
  get_user_system_message(e) {
    return _get_http(`/api/system_message/page`, e, 'GET');
  },

  /**
   * * 企业信息 用户分类 /api/common/position/public/userType/content
   * 企业信息 行业领域 /api/common/position/public/industry/content
   * 企业信息 交易类型 /api/common/position/public/tradeType/content
   */

  // 企业信息 用户分类
  get_userType_content(e) {
    return _get_http(`/api/common/position/public/userType/content`, e, 'GET');
  },

  // 企业信息 行业领域
  get_industry_content(e) {
    return _get_http(`/api/common/position/public/industry/content`, e, 'GET');
  },

  // 企业信息 交易类型
  get_tradeType_content(e) {
    return _get_http(`/api/common/position/public/tradeType/content`, e, 'GET');
  },

  // 获取我的企业信息 可能返回null
  get_user_company_me(e) {
    return _get_http(`/api/cdkelong_mall/user_company/me`, e, 'GET');
  },

  // 标记已读
  read_message(e) {
    return _get_http(`/api/system_message/${e}`, e, 'POST');
  },
  //我购买过的所有店铺
  purchase_store(e) {
    return _get_http(`/api/cdkelong_mall/orders/myBuyAllStore`, e, 'GET');
  },
  // 所有店铺
  all_store(e) {
    return _get_http(`/api/cdkelong_mall/store/public/all`, e, 'GET');
  },

  /**
   * * * 关于科隆 /api/common/position/public/about/content
   * 服务与支持 /api/common/position/public/serviceSupport/content
   * 订购指南 /api/common/position/public/orderGuide/content
   * 参考资料 /api/common/position/public/reference/content
   * 退换货流程说明 /api/common/position/public/returnProcess/content
   */

  // 关于科隆
  get_about_content(e) {
    return _get_http(`/api/common/position/public/about/content`, e, 'GET');
  },

  // 服务与支持
  get_serviceSupport_content(e) {
    return _get_http(`/api/common/position/public/serviceSupport/content`, e, 'GET');
  },

  // 订购指南
  get_orderGuide_content(e) {
    return _get_http(`/api/common/position/public/orderGuide/content`, e, 'GET');
  },

  // 参考资料
  get_reference_content(e) {
    return _get_http(`/api/common/position/public/reference/content`, e, 'GET');
  },

  // 退换货流程说明
  get_returnProcess_content(e) {
    return _get_http(`/api/common/position/public/returnProcess/content`, e, 'GET');
  },

  // 取消单个收藏
  dange_cancel_favorites(e) {
    return _get_http(`/api/cdkelong_mall/favorites/cancel?productId=${e}`, e, 'GET');
  },

  // 列出一级分类下对应的二级分类资源 firstSortId：对应第一分类ID
  get_secondSort_list(e) {
    return _get_http(`/api/cdkelong_mall/secondSort/list?firstSortId=${e}`, e, 'GET');
  },

  // 授信表格列表
  get_credit_list(e) {
    return _get_http(`/api/cdkelong_mall/credit/search`, e, 'GET');
  },

  // 授信记录
  get_searchPromote(e) {
    return _get_http(`/api/cdkelong_mall/credit/searchPromote?page=${e}&size=15`, e, 'GET');
  },

  // COA查询 productId：商品uuid，storeId：店铺ID，skuSn：批号
  get_productFile_coaSearch(e) {
    return _get_http(`/api/cdkelong_mall/productFile/public/coaSearch`, e, 'GET');
  },

  // 查询授权商品列表
  get_authorized_list(e) {
    return _get_http('/api/cdkelong_mall/user_product/page', e, 'GET')
  },
  // cnzz
  get_cnzzGetconfig(e) {
    return _get_http('/api/cnzz/public/scriptSrc', e, 'GET')
  },
  // 提交申请
  tijiao_purchase(e) {
    return _get_http(`/api/cdkelong_mall/find_goods_batch/public`, e, 'POST')
  },
  // 获取公共资源
  advertisementSet(e) {
    return _get_http(`/api/common/position/public/${e}/content`, e, 'GET')
  },
  // 查询
  set_advertisementSet(e) {
    return _get_http(`/api/common/position/public/${e}`, e, 'GET')
  },
  // 查询
  get_phone(e) {
    return _get_http(`/api/user_portal/me/mobile`, e, 'GET')
  },
  // 初次绑定 发送验证码
  get_code(e) {
    return _get_http(`/api/user/mobileFirst/verifycode?mobile=${e.mobile}&random=手机相关`, 'GET')
  },
  // 取消订单
  get_quxiao(e) {
    return _get_http(`api/cdkelong_mall/orders/backOrderCancel/${e}`, e, 'GET')
  },
  // 验证码校验 绑定
  set_code(e) {
    return request(`/api/user/mobileFirst/bind?verifycode=${e.verifycode}`, e, 'POST')
  },
  // 支付宝支付
  ordersZfbpay(e) {
    return request(`/api/cdkelong_mall/pay_order/orders/alipay`, {
      list: [e.batchModel],
      returnUrl:e.returnUrl
    }, 'POST')
  },
  //支付宝 查询
  ZfbpayPaid(e) {
    return request(`/api/cdkelong_mall/pay_order/${e}/checkPaid`, e, 'POST')
  },
  // 微信绑定
  wxbangding(e) {
    return request(`/api/oauth/public/login/${e}`, e, 'POST')
  },
  // // 微信登录方式
  wxlogin(e) {
    return _get_http(`/api/oauth/public/loginJump/${e}`, e, 'GET')
  },

  wxshenfen(e) {
    return request(`${e}`, e, 'POST')
  },
  wxjiebang(e) {
    return request(`/api/oauth/unbind/${e}`, e, 'POST')
  },
  // // QQ登录方式
  // qqlogin (e){
  //   return _get_http(`/api/oauth/public/loginJump/${e}`,e,'GET')
  // },
  // 用户信息
  dlzc(e) {
    return request(`/api/oauth/public/login/${e}`, e, 'POST')
  },
  // 是否支持支付宝
  zhifubao(e) {
    return _get_http(`/api/cdkelong_mall/ali_pay_config/${e}/public/usable`, e, 'GET')
  },
  // 是否支持微信
  weixin(e) {
    return _get_http(`/api/cdkelong_mall/store/wxpay/${e}/public/usable`, e, 'GET')
  },
  // 查询企业所有主账号
  companyAllAccount(e) {
    return request(`/api/cdkelong_mall/user_company/companyAllAccount?unifiedSocialCreditCode=${e.unifiedSocialCreditCode}&search=${e.search}`, {}, 'POST')
  },
  // 保存用户企业信息2
  save_user_company2({ getParameters, userCompany }) {
    return request(`/api/cdkelong_mall/user_company/saveMe?${getParameters}`, userCompany, 'POST');
  },
  //解绑手机号
  // unbound(data) {
  //   return request(`/api/auth/public/unbound`, {
  //     data,
  //     realm: 'system',
  //     type: 'mobile_code'
  //   }, 'POST')
  // }
  unbound({ mobile, code }) {
    return request(`/api/auth/public/unbound?mobile=${mobile}&code=${code}`, {}, 'POST')
  },
  //获取子账号或者主账号
  getAccountList(e) {
    return request(`/api/cdkelong_mall/user_company/accountList${e}`, {}, 'POST')
  },
  //获取账户是否绑定类型
  getCheckAccount({ usCode }) {
    return request(`/api/user/bindParent/checkAccount?usCode=${usCode}`, {}, 'POST')

  },
  //获取绑定解绑验证码
  sendCode({ type, phone }) {
    return request(`/api/user/bindParent/sendCode?type=${type}&phone=${phone}`, {}, 'GET')

  },
  //校验验证码,并绑定账号
  verificationCode(e) {
    return request(`/api/user/bindParent/code/valid`, e, 'POST')

  },
  //解绑账号
  unbind({ uuid }) {
    return request(`/api/user/bindParent/unbind?userId=${uuid}`, {}, 'POST')

  },
  //查询账号绑定
  getAccountList2() {
    return request(`/api/user/bindParent/accountList`, {}, 'GET')

  },
  /**获取是否拥有购买资格*/
  get_qualification(e) {
    return request(`api/cdkelong_mall/pay_order/orders/isAlipay`, e, 'POST')

  },
  /**获取随货资料列表*/
  getWithGoods({ storeId }) {
    return request(`/api/cdkelong_mall/order_remark_config/s/list?storeId=${storeId}`, {}, 'GET')

  },
  subWithGoods(parameter) {
    return request(`/api/cdkelong_mall/orders/updateOrcContent`, parameter, 'POST')
  },
  /**获取运费列表*/
  eachFreightFree(parameter) {
    return request(`/api/cdkelong_mall/cart/eachFreightFree`, parameter, 'POST')
  },
  /** 获取客服qq列表 */
  getQQListAll() {
    return request(`/api/cdkelong_mall/serviceQq/public/listAll`, {}, 'GET')
  },
  getAddress(e) {
    return request(`/api/cdkelong_mall/address/forward?keyword=${e.keyword}&region=${e.region}`, e, 'GET', false)
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js